export default "__VITE_ASSET__a22111b2__"